import interact from 'interactjs';

import HelptapEditor from '../../helpers';

var CONTAINER_SELECTORS = '.editor-node-main, .column-content-container';
var MIN_WIDTH = 30;
var MIN_HEIGHT = 30;

function findContainingParent(element) {

  var parent = element.parentNode;

  while (parent !== null && parent !== document.body) {

    if (parent.matches(CONTAINER_SELECTORS) === true) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return element.parentNode;

}

function getContainerInnerWidth(container) {

  var containerStyle = getComputedStyle(container);
  var paddingLeft = parseFloat(containerStyle.paddingLeft);
  var paddingRight = parseFloat(containerStyle.paddingRight);

  return container.offsetWidth - paddingLeft - paddingRight;

}

function computeMaxWidth(elementContainer) {

  var container = findContainingParent(elementContainer);
  var containerInnerWidth = getContainerInnerWidth(container);
  var containerRect = container.getBoundingClientRect();
  var elementRect = elementContainer.getBoundingClientRect();
  var containerStyle = getComputedStyle(container);
  var paddingRight = parseFloat(containerStyle.paddingRight);
  var availableWidth = containerRect.right - paddingRight - elementRect.left;

  return Math.min(containerInnerWidth, availableWidth);

}

function convertToPercentageWidth(elementContainer, pixelWidth) {

  var container = findContainingParent(elementContainer);
  var containerInnerWidth = getContainerInnerWidth(container);
  var percentage = (pixelWidth / containerInnerWidth) * 100;

  return percentage.toFixed(2) + '%';

}

function handleResizeMove(event) {

  var rect = event.rect;
  var target = event.target;

  target.style.width = rect.width.toFixed(2) + 'px';
  target.style.height = rect.height.toFixed(2) + 'px';

}

function handleResizeStart(editor, event) {

  event.target.classList.add('resizing');
  HelptapEditor.clearSelection(editor);

}

function handleResizeEnd(editor, elementPathReference, event) {

  var element = event.target;

  element.classList.remove('resizing');

  var elementRect = element.getBoundingClientRect();
  var widthPercent = convertToPercentageWidth(element, elementRect.width);
  var heightPx = elementRect.height.toFixed(2) + 'px';

  var dimension = {
    width: widthPercent,
    height: heightPx
  };

  var pathRef = elementPathReference.current;

  if (pathRef === null || pathRef.current === null) {
    return;
  }

  HelptapEditor.setAttributes(editor, dimension, pathRef.current);

}

export function initializeResizability(editor, elementContainer, elementPathReference) {

  var interactable = interact(elementContainer)
    .resizable({

      edges: { left: false, right: true, bottom: true, top: false },

      modifiers: [
        interact.modifiers.restrictSize({
          min: { width: MIN_WIDTH, height: MIN_HEIGHT },
          max: function determineMaxSize() {
            return { width: computeMaxWidth(elementContainer), height: Infinity };
          }
        })
      ],

      listeners: {
        start: handleResizeStart.bind(null, editor),
        move: handleResizeMove,
        end: handleResizeEnd.bind(null, editor, elementPathReference)
      },

      inertia: false

    });

  return function uninitialize() {
    interactable.unset();
  };

}
